// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
var Locale = function (x) {
    return x;
};
var Currency = function (x) {
    return x;
};
var formatCurrency = /* #__PURE__ */ Data_Function_Uncurried.runFn3($foreign.formatCurrency_);
export {
    Locale,
    Currency,
    formatCurrency
};
//# sourceMappingURL=index.js.map
